import moment from 'moment'

/**
 * Returns the date range {start, end} as 'YYYY-MM-DD' strings for a given period preset.
 * Returns null for 'custom' (caller provides the dates).
 *
 * @param {string} period
 * @returns {{ start: string, end: string } | null}
 */
export function getDateRangeForPeriod(period) {
  switch (period) {
    case 'today':
      return {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    case 'this_week':
      return {
        start: moment().startOf('week').format('YYYY-MM-DD'),
        end: moment().endOf('week').format('YYYY-MM-DD')
      }
    case 'last_week':
      return {
        start: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
        end: moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD')
      }
    case 'this_month':
      return {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      }
    case 'last_month':
      return {
        start: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        end: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
      }
    case 'this_quarter':
      return {
        start: moment().startOf('quarter').format('YYYY-MM-DD'),
        end: moment().endOf('quarter').format('YYYY-MM-DD')
      }
    case 'last_quarter':
      return {
        start: moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'),
        end: moment().subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD')
      }
    case 'this_year':
      return {
        start: moment().startOf('year').format('YYYY-MM-DD'),
        end: moment().endOf('year').format('YYYY-MM-DD')
      }
    case 'last_year':
      return {
        start: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
        end: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
      }
    case 'custom':
    default:
      return null
  }
}

/**
 * Returns a translation key for each period preset value.
 * Consumers call $t(key) themselves.
 *
 * @returns {Array<{ value: string, labelKey: string }>}
 */
export function getStandardPeriodPresets() {
  return [
    { value: 'today',        labelKey: 'global.today' },
    { value: 'this_week',    labelKey: 'global.this_week' },
    { value: 'last_week',    labelKey: 'global.last_week' },
    { value: 'this_month',   labelKey: 'global.this_month' },
    { value: 'last_month',   labelKey: 'global.last_month' },
    { value: 'this_quarter', labelKey: 'global.this_quarter' },
    { value: 'last_quarter', labelKey: 'global.last_quarter' },
    { value: 'this_year',    labelKey: 'global.this_year' },
    { value: 'last_year',    labelKey: 'global.last_year' },
    { value: 'custom',       labelKey: 'global.custom_period' },
  ]
}
